import './floating.css';

const phoneIntl = '+972502044391';

function Icon({ type }) {
  const common = { width: 22, height: 22, viewBox: '0 0 24 24', fill: 'none', xmlns: 'http://www.w3.org/2000/svg' };
  if (type === 'whatsapp') {
    return (
      <svg {...common} aria-hidden="true">
        <path
          d="M12 2a9.5 9.5 0 0 0-8.22 14.3L3 22l5.9-1.55A9.5 9.5 0 1 0 12 2Z"
          stroke="currentColor"
          strokeWidth="1.8"
          strokeLinejoin="round"
        />
        <path
          d="M9.6 8.8c.18-.41.37-.42.55-.42h.47c.12 0 .3.04.45.34.16.3.53 1.3.58 1.39.05.09.08.2.01.33-.07.12-.1.2-.2.31-.09.1-.2.22-.28.3-.1.1-.2.2-.08.4.12.2.53.86 1.13 1.39.78.69 1.44.9 1.64 1 .2.1.32.08.44-.05.12-.12.5-.58.64-.78.14-.2.27-.17.45-.1.18.07 1.14.54 1.33.64.2.1.33.15.37.24.04.09.04.52-.12 1.02-.16.5-.94.98-1.3 1.04-.35.06-.8.09-1.29-.08-.3-.1-.68-.22-1.16-.43a9.86 9.86 0 0 1-3.37-2.48 11.29 11.29 0 0 1-1.7-2.27c-.18-.34-.7-1.28-.7-2.45 0-1.17.62-1.75.84-1.98Z"
          fill="currentColor"
        />
      </svg>
    );
  }
  return (
    <svg {...common} aria-hidden="true">
      <path
        d="M20 16.6v2a1.4 1.4 0 0 1-1.5 1.4A17.3 17.3 0 0 1 4 5.5 1.4 1.4 0 0 1 5.4 4h2a1.4 1.4 0 0 1 1.4 1.2c.1.7.3 1.4.6 2a1.4 1.4 0 0 1-.3 1.5l-.8.8a14 14 0 0 0 5.2 5.2l.8-.8a1.4 1.4 0 0 1 1.5-.3c.6.3 1.3.5 2 .6A1.4 1.4 0 0 1 20 16.6Z"
        stroke="currentColor"
        strokeWidth="1.8"
        strokeLinejoin="round"
      />
    </svg>
  );
}

export function FloatingActions() {
  return (
    <div className="floating" aria-label="أزرار سريعة">
      <a
        className="fab fabWhats"
        href={`https://wa.me/${phoneIntl.replace('+', '')}`}
        target="_blank"
        rel="noreferrer"
        aria-label="واتساب"
        title="واتساب"
      >
        <Icon type="whatsapp" />
      </a>
      <a
        className="fab fabCall"
        href={`tel:${phoneIntl}`}
        aria-label="اتصال مباشر"
        title="اتصال"
      >
        <Icon type="call" />
      </a>
    </div>
  );
}

